import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export function groupAuditTasksReducer(state = initialState.groupAuditTasks, action) {
	switch (action.type) {
		case types.GET_GROUP_AUDIT_TASKS: {
			return {...action.response, fetchPendingEvidence: true};
		}
		case types.GET_PENDING_EVIDENCE: {
			return {...state, pendingEvidenceCount: action.response.pendingEvidenceCount, fetchPendingEvidence: false};
		}
		case types.GET_COMPONENTS: {
			return {
				...state,
				groupTaskComponents: action.response.groupTaskComponents,
				isMappedToOtherPGT: action.response.isMappedToOtherPGT,
				mappedComponentName: action.response.mappedComponentName
			};
		}
		case types.RESET_TASK_ATTRIBUTES:
		case types.CLEAN_PENDING_EVIDENCE: {
			return {...state, fetchPendingEvidence: true};
		}
		default:
			return state;
	}
}
